import React from 'react';
import '../../Default.css';
import './Designs.css'
import designsData from "./designs.json"
import { Design } from './designsType';
const designs: Design[] = designsData as any;


function Designs() {
    return (
      <>
        <div className="page-title">
          Designs
        </div>
        <div className='designs-containter'>
          {designs.map((design, index) => 
            <div key={index} className='text-box'>
              <div className='text-box-header'>
                {design.name}
              </div>
              {design.images.map((image, index) => 
                <div key={index}>
                  <img src={image.src} alt={design.name} className='photo'/>
                  <div className='copyright copyright-tekst'>
                    <a href={image.copyright.url}>link to source of image ({image.copyright.domainName})</a>
                  </div>
                </div>
              )}
            </div>
        )}
        </div>
      </>
    );
}

export default Designs;
